<template>
    <div>
        <board-write-link v-for="writeLayout in writeLayouts" :key="`boardCategory${writeLayout}`"
                          :writeLayout="writeLayout" :boardData="boardData"></board-write-link>
    </div>
</template>

<script>
import BoardWriteLink from "@/components/board/BoardWriteLink";
import alertMixins from "@/mixins/alertMixins";
import EventBus from "@/utils/event-bus";
import util from "@/mixins/util";
import boardTemplateUtil from "@/components/board/boardTemplateUtil";
import boardFilterUtil from "@/components/board/boardFilterUtil";
import boardValidator from "@/mixins/validators/boardValidator";
import DeleteClass from "@/mixins/deleteClass";

export default {
    name: "BoardCategoryComponent",
    mixins: [alertMixins, boardTemplateUtil, boardFilterUtil, boardValidator],
    components: {BoardWriteLink},
    inject: ['changeLoading'],
    provide() {
        return {
            boardWriteSetData: this.setData,
            writeCategory: this.runWriteConfirm,
            deleteCategory: this.runDeleteConfirm,
        }
    },
    props: {
        boardType: {},
    },
    data() {
        return {
            writeLayouts: [],
            writeFunc: '',
            writeApiParamSet: {},
            parsingData: {},
            directUrl: '',
            directType: '',
            keyName: '',
            writeSuccessType: 1,
            writeFailTypes: {},
            getFunc: '',
            detailApiParamsSet: {},
            boardData: [],

            deleteFunc: '',
            deleteApiParamsSet: '',
            deleteSuccessType: '',
            deleteFailTypes: '',
        }
    },
    created() {
        this.initConfig();
        this.newDeleteClass();
        this.getCategory();
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        setData(key, value) {
            this[key] = value;
        },
        initConfig() {
            let configTemplateBoard = this.returnBoardTemplateConfig(this.boardType);
            this.writeLayouts = configTemplateBoard.writeLayouts;

            let configBoard = this.returnBoardFilterConfig(this.boardType);
            this.writeFunc = configBoard.writeFunc;
            this.writeApiParamSet = configBoard.writeApiParamSet;
            this.parsingData = configBoard.parsingData;
            this.getFunc = configBoard.getFunc;
            this.detailApiParamsSet = configBoard.detailApiParamsSet;
            this.keyName = configBoard.keyName;
            this.writeSuccessType = configBoard.writeSuccessType;
            this.writeFailTypes = configBoard.writeFailTypes;

            this.deleteFunc = configBoard.deleteFunc;
            this.deleteApiParamsSet = configBoard.deleteApiParamsSet;
            this.deleteSuccessType = configBoard.deleteSuccessType;
            this.deleteFailTypes = configBoard.deleteFailTypes;
        },

        getCategory() {
            let params = JSON.parse(JSON.stringify(this.detailApiParamsSet));
            // !util.isEmpty(this.keyName) ? params[this.keyName] = this.boardKey : params.id = this.boardKey;
            this.$api.$board[this.getFunc](params).then(res => res.Data.Result).then(res => {
                if (res.Info.type != 1) {
                    this.createAlert({
                        title: '',
                        content: '데이터를 불러올 수 없습니다.',
                        btnText: '확인',
                        hide: () => {
                            this.$router.back();
                        }
                    });
                    return;
                }
                this.boardData = res.List;
            })
        },
        newDeleteClass() {
            let deleteOptions = {
                func: this.$api.$board[this.deleteFunc],
                apiParamSet: this.deleteApiParamsSet,
                keyName: this.keyName,
                errorTypes: this.deleteFailTypes,
                successType: this.deleteSuccessType,
                afterFunc: this.deleteAfterFunc,
            }
            this.DeleteClass = new DeleteClass(deleteOptions);
        },
        runWriteConfirm(boardKey, seq, name) {
            this.createConfirm({
                content: '저장하시겠습니까?',
                confirm: () => {
                    this.name = name;
                    this.seq = seq;
                    this.checkValidator(boardKey, seq, name);
                }
            })
        },
        runDeleteConfirm(boardKey) {
            this.createConfirm({
                content: '삭제하시겠습니까?',
                confirm: () => {
                    this.bc_idx = boardKey;
                    this.runDelete();
                }
            })
        },
        returnBoardType(type) {
            if (type == this.writeSuccessType) {
                return true;
            } else {
                return util.isEmpty(this.writeFailTypes[type]) ? '카테고리명 중복으로 인해 실패하였습니다.' : this.writeFailTypes[type]
            }
        },
        checkValidator(boardKey, seq, name) {
            let validatorArr = ['name', 'seq'];
            this.$validate(validatorArr).then(success => {
                if (success) {
                    this.writeCategory(boardKey, seq, name);
                } else {
                    this.errorAlert('입력 정보를 확인해주세요.');
                }
            })
        },
        writeCategory(boardKey, seq, name) {
            if (this.isRunning) {
                return false;
            }
            this.changeLoading(true);
            let params = JSON.parse(JSON.stringify(this.writeApiParamSet));
            console.log(boardKey);
            if(boardKey == null){
                this.writeFunc = 'createCategory';
            }else{
                params.bc_idx = boardKey;
            }
            params.bc_name = name;
            params.bc_seq = seq;
            try {
                this.$api.$board[this.writeFunc](params).then(res => res.Data.Result).then(res => {
                    let type = this.returnBoardType(res.Info.type);
                    if (type != true) {
                        this.changeLoading(false);
                        this.errorAlert(type);
                        return false;
                    } else {
                        this.afterFunc();
                    }
                })
            } catch (e) {
                this.changeLoading(false);
                console.log(e);
            }
        },
        runDelete(){
            this.changeLoading(true);
            this.DeleteClass.runDelete(this.bc_idx);
        },
        afterFunc() {
            this.changeLoading(false);
            this.getCategory();
            // EventBus.$emit('initCategoryData');
            this.createAlert({
                title: '',
                content: '저장되었습니다.',
                btnText: '확인',
                hide: () => {
                }
            })
        },
        deleteAfterFunc() {
            this.changeLoading(false);
            this.getCategory();
            this.createAlert({
                title: '',
                content: '삭제되었습니다.',
                btnText: '확인',
                hide: () => {
                }
            })
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
